let keepsakePortraitInitialized = false;

function setupKeepsakePortrait(dogIdParam) {
    if (keepsakePortraitInitialized) {
        return;
    }

    const input = document.querySelector('#petPhoto.upload-input') || document.querySelector('.upload-input');
    const uploadWrap = document.querySelector('.upload-wrap');
    const uploadCard = uploadWrap && uploadWrap.querySelector('.upload-card');
    const uploadSection = document.querySelector('.upload-section');
    const previewSection = document.querySelector('.preview-section');
    const previewImage =
        (previewSection && previewSection.querySelector('.preview-image img')) ||
        (previewSection && previewSection.querySelector('img'));

    if (!input || !uploadCard) {
        return;
    }

    keepsakePortraitInitialized = true;

    const config = window.pawPrintConfig || {};
    const apiUniversalUrl = 'https://apif.thepawprint.store/offers';
    const apiBaseUrl = apiUniversalUrl + '/keepsake-portrait';
    const urlParams = new URLSearchParams(window.location.search);
    const existingOfferId = (() => {
        const id = urlParams.get('id');
        return id && id !== 'null' ? id : null;
    })();
    const keepsakeReminder = urlParams.get('krmnd') === 'true';
    const orderId = urlParams.get('orderId');
    const utmCampaign = urlParams.get('utm_campaign');
    const utmContent = urlParams.get('utm_content');
    const utmSource = urlParams.get('utm_source');
    const utmTerm = urlParams.get('utm_term');
    const fbclid = urlParams.get('fbclid');
    const expId = urlParams.get('expid');
    const varId = urlParams.get('varid');
    const aiPromptTemplateSlug = urlParams.get('apts');
    const hideBundle = urlParams.get('hb') === 'true';
    const resolvedDogIdParam = dogIdParam || null;

    const loadingMessages = [
        'Sketching the perfect keepsake for your pet.',
        'Adding the details that make your pet one of a kind.',
        'Matching colors to your pets personality.',
        'Bringing your pets charm to life.',
        'Crafting a portrait worth framing.',
        'Finalizing the keepsake magic.',
        'Warming up the brushes for your best friend.',
        'Building a keepsake you will want to show off.',
        'Turning that photo into a lasting memory.',
        'Almost ready to reveal the keepsake portrait.',
    ];

    let messageIndex = 0;
    let messageTimer = null;
    let countdownTimer = null;
    let countdownStart = null;
    let pollTimer = null;
    let pollDelayTimer = null;
    let pollPaceTimer = null;
    let pollSlowTimer = null;
    let pollStopTimer = null;
    let isProcessing = false;
    const viewedOfferIds = new Set();
    const viewedOfferStorageKey = 'keepsake_viewed_offer_ids';
    try {
        const storedViewedOffers = JSON.parse(localStorage.getItem(viewedOfferStorageKey) || '[]');
        if (Array.isArray(storedViewedOffers)) {
            storedViewedOffers.forEach((id) => {
                if (id) {
                    viewedOfferIds.add(String(id));
                }
            });
        }
    } catch (error) {
        console.warn('Failed to read viewed offer ids from storage', error);
    }

    const clearPollTimers = () => {
        if (pollTimer) {
            clearInterval(pollTimer);
            pollTimer = null;
        }
        if (pollDelayTimer) {
            clearTimeout(pollDelayTimer);
            pollDelayTimer = null;
        }
        if (pollPaceTimer) {
            clearTimeout(pollPaceTimer);
            pollPaceTimer = null;
        }
        if (pollSlowTimer) {
            clearTimeout(pollSlowTimer);
            pollSlowTimer = null;
        }
        if (pollStopTimer) {
            clearTimeout(pollStopTimer);
            pollStopTimer = null;
        }
    };

    const clearTimers = () => {
        if (messageTimer) {
            clearInterval(messageTimer);
            messageTimer = null;
        }
        if (countdownTimer) {
            clearInterval(countdownTimer);
            countdownTimer = null;
        }
        clearPollTimers();
    };

    const updateLoadingMessage = (loadingText) => {
        if (!loadingText) return;
        loadingText.textContent = loadingMessages[messageIndex % loadingMessages.length];
        messageIndex += 1;
    };

    const updateCountdownMessage = (countdownText) => {
        if (!countdownText || countdownStart === null) return;
        const elapsedSeconds = Math.floor((Date.now() - countdownStart) / 1000);
        const remainingSeconds = Math.max(0, 60 - elapsedSeconds);

        if (elapsedSeconds >= 75) {
            countdownText.textContent = 'This is taking a little longer than usual. Hang tight though.';
        } else if (remainingSeconds <= 10) {
            countdownText.textContent = 'Any moment now...';
        } else {
            countdownText.textContent = `About ${remainingSeconds} seconds remaining...`;
        }
    };

    const showLoadingError = (message) => {
        const loadingEl = uploadCard.querySelector('.keepsake-upload-loading');
        const loadingText = loadingEl && loadingEl.querySelector('.keepsake-loading-text');
        const spinner = loadingEl && loadingEl.querySelector('.keepsake-spinner');

        if (messageTimer) {
            clearInterval(messageTimer);
            messageTimer = null;
        }
        if (countdownTimer) {
            clearInterval(countdownTimer);
            countdownTimer = null;
        }

        if (spinner) {
            spinner.style.display = 'none';
        }

        if (loadingText) {
            loadingText.textContent = message;
        }

        uploadCard.classList.remove('keepsake-loading');
        input.disabled = false;
    };

    const notifyOfferViewed = (offerId) => {
        if (!offerId || viewedOfferIds.has(offerId)) {
            return;
        }

        fetch(`${apiUniversalUrl}/${offerId}/viewed`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${config.fApiToken || ''}`,
            },
        })
            .then((response) => {
                if (!response || !response.ok) {
                    throw new Error('Non-200 response');
                }
                viewedOfferIds.add(offerId);
                localStorage.setItem(viewedOfferStorageKey, JSON.stringify(Array.from(viewedOfferIds)));
            })
            .catch((error) => {
                console.error('Failed to notify keepsake offer viewed', error);
            });
    };

    const setLoadingState = (loading) => {
        const uploadCenter = uploadCard.querySelector('.upload-center');
        const uploadStyle = uploadCard.querySelector('.upload-style');
        let loadingEl = uploadCard.querySelector('.keepsake-upload-loading');

        if (loading) {
            uploadCard.classList.add('keepsake-loading');
            input.disabled = true;

            if (uploadCenter) uploadCenter.style.display = 'none';
            if (uploadStyle) uploadStyle.style.display = 'none';

            if (!loadingEl) {
                loadingEl = document.createElement('div');
                loadingEl.className = 'keepsake-upload-loading';
                loadingEl.innerHTML =
                    '<div class="keepsake-spinner" aria-hidden="true"></div><div class="keepsake-loading-text" aria-live="polite"></div><div class="keepsake-loading-countdown" aria-live="polite"></div><div class="keepsake-loading-bar" aria-hidden="true"><div class="keepsake-loading-bar__fill"></div></div>';
                uploadCard.appendChild(loadingEl);
            }

            const loadingText = loadingEl.querySelector('.keepsake-loading-text');
            const countdownText = loadingEl.querySelector('.keepsake-loading-countdown');
            const progressFill = loadingEl.querySelector('.keepsake-loading-bar__fill');
            messageIndex = 0;
            updateLoadingMessage(loadingText);
            if (!messageTimer) {
                messageTimer = setInterval(() => updateLoadingMessage(loadingText), 5000);
            }
            countdownStart = Date.now();
            updateCountdownMessage(countdownText);
            if (!countdownTimer) {
                countdownTimer = setInterval(() => updateCountdownMessage(countdownText), 5000);
            }
            if (progressFill) {
                progressFill.classList.remove('keepsake-loading-bar__fill--active');
                progressFill.style.animation = 'none';
                progressFill.offsetWidth;
                progressFill.style.animation = '';
                progressFill.classList.add('keepsake-loading-bar__fill--active');
            }
        } else {
            uploadCard.classList.remove('keepsake-loading');
            input.disabled = false;

            if (uploadCenter) uploadCenter.style.display = '';
            if (uploadStyle) uploadStyle.style.display = '';

            if (loadingEl) {
                loadingEl.remove();
            }
            countdownStart = null;
            clearTimers();
        }
    };

    const updateUrlWithOfferId = (offerId) => {
        try {
            const url = new URL(window.location.href);
            url.searchParams.set('id', offerId);
            window.history.replaceState({}, '', url.toString());
        } catch (error) {
            console.error('Failed to update URL with offer id', error);
        }
    };

    const updateUploadSectionImages = () => {
        if (!uploadSection) {
            return;
        }

        const imageUrls = window._apts && Array.isArray(window._apts.image_urls) ? window._apts.image_urls : null;
        if (!imageUrls || imageUrls.length < 3) {
            return;
        }

        const pictures = uploadSection.querySelectorAll('.preview-images-row .preview-image-wrapper picture');
        if (pictures.length < 3) {
            return;
        }

        imageUrls.slice(0, 3).forEach((url, index) => {
            const picture = pictures[index];
            if (!url || !picture) {
                return;
            }

            const img = picture.querySelector('img');
            if (!img || !picture.parentElement) {
                return;
            }

            const replacement = document.createElement('img');
            if (img.className) {
                replacement.className = img.className;
            }
            if (img.getAttribute('style')) {
                replacement.setAttribute('style', img.getAttribute('style'));
            }
            replacement.src = url;
            replacement.setAttribute('srcset', url);

            picture.parentElement.insertBefore(replacement, picture);
            picture.remove();
        });
    };

    const aptsDataReadyHandler = () => {
        console.log('APTS data is ready, updating upload section images');
        updateUploadSectionImages();
    };

    const onDomContentLoadedHandler = () => {
        console.log('DOM fully loaded, updating make another image url');
        updateMakeAnotherImageUrl();
    };

    if (window._apts && window._apts.image_urls) {
        aptsDataReadyHandler();
    } else {
        window.addEventListener('tppData:aptsReady', aptsDataReadyHandler);
    }

    document.addEventListener('DOMContentLoaded', onDomContentLoadedHandler);

    const updateMakeAnotherImageUrl = () => {
        const link = document.querySelector('.repeat-image-button a');
        if (!link) {
            return;
        }

        try {
            const url = new URL(window.location.href);
            url.searchParams.delete('id');
            url.searchParams.delete('krmnd');
            link.setAttribute('href', url.toString());
        } catch (error) {
            console.error('Failed to update make another image url', error);
        }
    };

    const updateAttributionWithOfferId = (offerId) => {
        if (!offerId || typeof window.configureAttribution !== 'function') {
            return;
        }

        const dogId = localStorage.getItem('dog_id') || (window.getDogIDCookie && window.getDogIDCookie());
        const assignmentOfferId = localStorage.getItem('url_assignment_offer_id');
        const campaign = localStorage.getItem('campaign') || (window.getCampaignCookie && window.getCampaignCookie());

        const attrData = { dogId, assignmentOfferId, campaign, offer_id: offerId };
        window.configureAttribution(attrData);
    };

    const CLOUDINARY_BASE = 'https://res.cloudinary.com/da9yd4bgx/image/fetch';
    const WATERMARK_TRANSFORM =
        'c_scale,w_600/l_static:tpp-watermark-d/c_scale,w_600/fl_layer_apply,g_south_east,fl_no_overflow';
    const CANVAS_TRANSFORM = 't_canvas-mockup-v1';
    const PUZZLE_TRANSFORM = 't_puzzle-v1';
    const MOCKUP_WIDTH = 'w_480';
    let mockupRetryCount = 0;

    const buildWatermarkedUrl = (imageUrl) => {
        if (!imageUrl) {
            return null;
        }

        return `${CLOUDINARY_BASE}/${WATERMARK_TRANSFORM}/${encodeURIComponent(imageUrl)}`;
    };

    const buildMockupUrl = (transform, imageUrl) => {
        if (!imageUrl) {
            return null;
        }

        return `${CLOUDINARY_BASE}/${transform}/${MOCKUP_WIDTH}/${encodeURIComponent(imageUrl)}`;
    };

    const revealDownloadRow = (originalImageUrl) => {
        if (!originalImageUrl) {
            return;
        }

        const downloadRow = document.querySelector('.portrait-download-button-row');
        if (!downloadRow) {
            return;
        }

        downloadRow.style.display = 'block';

        const downloadButton = downloadRow.querySelector('button');
        if (downloadButton) {
            downloadButton.onclick = () => {
                window.open(originalImageUrl, '_blank');
            };
        }
    };

    const renderPricingCardMockups = (displayUrl, sourceUrl) => {
        if (!displayUrl || !sourceUrl) {
            return;
        }

        const cards = document.querySelectorAll('.pricing-card');
        if (!cards || cards.length < 3) {
            if (mockupRetryCount < 6) {
                mockupRetryCount += 1;
                setTimeout(() => renderPricingCardMockups(imageUrl), 400);
            }
            return;
        }

        const targets = [
            { card: cards[0], url: displayUrl, alt: 'Keepsake preview' },
            { card: cards[1], url: buildMockupUrl(CANVAS_TRANSFORM, sourceUrl), alt: 'Canvas mockup' },
            { card: cards[2], url: buildMockupUrl(PUZZLE_TRANSFORM, sourceUrl), alt: 'Puzzle mockup' },
        ];

        targets.forEach(({ card, url, alt }) => {
            if (!card || !url) {
                return;
            }

            const pricingInner = card.querySelector('.pricing-inner');
            const title = pricingInner && pricingInner.querySelector('.pricing-title');
            if (!pricingInner || !title || pricingInner.querySelector('.keepsake-pricing-mockup')) {
                return;
            }

            const img = document.createElement('img');
            img.className = 'keepsake-pricing-mockup';
            img.src = url;
            img.alt = alt;
            img.loading = 'lazy';
            img.setAttribute('draggable', 'false');
            img.addEventListener('contextmenu', (event) => event.preventDefault());
            img.addEventListener('dragstart', (event) => event.preventDefault());
            pricingInner.insertBefore(img, title);
        });

        enableKeepsakeLightbox();
    };

    const ensureKeepsakeLightboxInstance = () => {
        if (!window.GLightbox) {
            return;
        }

        if (!window._keepsakeLightbox) {
            window._keepsakeLightbox = GLightbox({
                touchNavigation: true,
                loop: true,
                selector: '.glightbox-keepsake',
            });
        } else if (typeof window._keepsakeLightbox.reload === 'function') {
            window._keepsakeLightbox.reload();
        }
    };

    const wrapImageForKeepsakeLightbox = (img, href) => {
        if (!img || !href || !img.parentElement) {
            return;
        }

        const existingLink = img.closest('a');
        if (existingLink && existingLink.classList.contains('glightbox-keepsake')) {
            existingLink.href = href;
            return;
        }

        const link = document.createElement('a');
        link.href = href;
        link.dataset.type = 'image';
        link.dataset.gallery = 'keepsake-gallery';
        link.className = 'glightbox-keepsake';
        img.parentElement.insertBefore(link, img);
        link.appendChild(img);
    };

    const enableKeepsakeLightbox = () => {
        const previewImg = previewSection && previewSection.querySelector('.preview-image img');
        if (previewImg) {
            wrapImageForKeepsakeLightbox(previewImg, previewImg.currentSrc || previewImg.src);
        }

        const mockups = document.querySelectorAll('img.keepsake-pricing-mockup');
        mockups.forEach((img) => {
            wrapImageForKeepsakeLightbox(img, img.currentSrc || img.src);
        });

        ensureKeepsakeLightboxInstance();
    };

    const parseTimerValue = (value) => {
        if (!value) {
            return null;
        }

        const parts = value.trim().split(':').map((part) => Number(part));
        if (parts.some((part) => Number.isNaN(part))) {
            return null;
        }

        if (parts.length === 3) {
            return parts[0] * 3600 + parts[1] * 60 + parts[2];
        }

        if (parts.length === 2) {
            return parts[0] * 60 + parts[1];
        }

        return null;
    };

    const formatTimerValue = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);
        const pad = (value) => String(value).padStart(2, '0');

        return `${hours}:${pad(minutes)}:${pad(seconds)}`;
    };

    const startPricingTimers = () => {
        const timers = document.querySelectorAll('.pricing-timer .timer-strong');
        if (!timers || !timers.length) {
            return;
        }

        timers.forEach((timerEl) => {
            if (!timerEl || timerEl.dataset.timerInitialized) {
                return;
            }

            const startingSeconds = parseTimerValue(timerEl.textContent);
            if (startingSeconds === null) {
                return;
            }

            let remainingSeconds = startingSeconds;
            timerEl.textContent = formatTimerValue(remainingSeconds);
            timerEl.dataset.timerInitialized = 'true';

            const intervalId = setInterval(() => {
                remainingSeconds -= 1;
                if (remainingSeconds <= 0) {
                    timerEl.textContent = formatTimerValue(0);
                    clearInterval(intervalId);
                    return;
                }

                timerEl.textContent = formatTimerValue(remainingSeconds);
            }, 1000);
        });
    };

    const bindPricingLinkModal = () => {
        const buttons = document.querySelectorAll('.pricing-footer button.footer-link');
        if (!buttons.length) {
            return;
        }

        buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                if (typeof window.showKeepsakeBundleModal !== 'function') {
                    return;
                }

                event.preventDefault();
                window.showKeepsakeBundleModal();
            });
        });
    };

    const addKeepsakeButtonCopies = (productElement) => {
        if (hideBundle) {
            return;
        }

        if (!productElement) {
            console.log('No product element provided');
            return;
        }

        if (productElement.dataset.keepsakeButtonsCopied === 'true') {
            console.log('Keepsake buttons already copied for this product element');
            return;
        }

        const primarySelector = 'gp-product form gp-row div:nth-child(2) gp-product-button';

        const scopedPrimarySelector = primarySelector.replace('gp-product ', '');
        const primaryButtonElement = productElement.querySelector(scopedPrimarySelector);

        if (!primaryButtonElement) {
            console.log('Could not find primary button element');
            return;
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'keepsake-product-buttons';
        const form = document.createElement('form');
        const productForm = document.createElement('product-form');
        productForm.className = 'product-form';

        const primaryClone = primaryButtonElement.cloneNode(true);
        [primaryClone].forEach((clone) => {
            clone.querySelectorAll('script').forEach((script) => script.remove());
        });

        wrapper.appendChild(primaryClone);
        form.appendChild(wrapper);
        productForm.appendChild(form);

        if (productElement.parentElement) {
            productElement.parentElement.insertBefore(productForm, productElement);
        }

        const originalButtonsContainer = productElement.querySelector('form gp-row div:nth-child(2)');
        if (originalButtonsContainer) {
            originalButtonsContainer.style.display = 'none';
        } else {
            primaryButtonElement.style.display = 'none';
        }
        productElement.dataset.keepsakeButtonsCopied = 'true';

        const primaryOriginalButton = primaryButtonElement.querySelector('button') || primaryButtonElement;
        const primaryCopyButton = primaryClone.querySelector('button');

        const openBundleModal = (originalButton, modalOptions) => (event) => {
            if (event && typeof event.preventDefault === 'function') {
                event.preventDefault();
            }
            if (event && typeof event.stopPropagation === 'function') {
                event.stopPropagation();
            }

            if (typeof window.showKeepsakeBundleModal !== 'function') {
                if (originalButton && typeof originalButton.click === 'function') {
                    originalButton.click();
                }
                return;
            }

            const options = Object.assign({}, modalOptions, {
                onClose: (detail) => {
                    const reason = detail && detail.reason;
                    if (reason !== 'close' && reason !== 'no-thanks' && reason !== 'overlay') {
                        return;
                    }
                    if (originalButton && typeof originalButton.click === 'function') {
                        originalButton.click();
                    }
                },
            });

            window.showKeepsakeBundleModal(options);
        };

        if (primaryCopyButton) {
            const modalOptions = {
                noThanksText: 'Proceed to Cart',
                noThanksClass: 'kb-continue',
                noThanksWrapClass: 'kb-no-thanks-wrap--right',
                getPrimaryItemDetails: () => {
                    const pricingCard = productElement.closest('.pricing-card');
                    if (!pricingCard) {
                        return null;
                    }

                    const titleEl = pricingCard.querySelector('.pricing-title');
                    const priceEl = pricingCard.querySelector('.price-now') || pricingCard.querySelector('.pricing-price');
                    const priceWasEl = pricingCard.querySelector('.price-was');
                    const imageEl =
                        pricingCard.querySelector('img.keepsake-pricing-mockup') || pricingCard.querySelector('img');

                    const title = titleEl ? titleEl.textContent.trim() : '';
                    const price = priceEl ? priceEl.textContent.trim() : '';
                    const priceWas = priceWasEl ? priceWasEl.textContent.trim() : '';
                    let imageUrl = imageEl ? (imageEl.currentSrc || imageEl.src || '') : '';
                    if (!imageUrl && window._offer) {
                        const offer = window._offer || {};
                        const resizedUrls = offer.resize_image_urls || {};
                        const sourceUrl = resizedUrls['600'] || resizedUrls['480'] || offer.image_url || '';
                        if (sourceUrl) {
                            const previewUrl = buildWatermarkedUrl(sourceUrl) || sourceUrl;
                            const mockupUrls = [
                                previewUrl,
                                buildMockupUrl(CANVAS_TRANSFORM, sourceUrl),
                                buildMockupUrl(PUZZLE_TRANSFORM, sourceUrl),
                            ];
                            const allCards = Array.from(document.querySelectorAll('.pricing-card'));
                            const cardIndex = allCards.indexOf(pricingCard);
                            imageUrl = mockupUrls[cardIndex] || mockupUrls[0] || '';
                        }
                    }

                    if (!title && !price && !imageUrl) {
                        return null;
                    }

                    return { imageUrl, title, price, priceWas };
                },
            };
            primaryCopyButton.addEventListener('click', openBundleModal(primaryOriginalButton, modalOptions));
        }
    };

    const rearrangePricingCards = () => {
        const productOptionsRow = document.querySelector('.product-options');
        if (!productOptionsRow) {
            return;
        }

        const columns = Array.from(productOptionsRow.children);
        columns.forEach((column) => {
            const pricingCard = column.querySelector('.pricing-card');
            const pricingInner = pricingCard && pricingCard.querySelector('.pricing-inner');
            const pricingList = pricingInner && pricingInner.querySelector('.pricing-list');
            const productElement = column.querySelector('gp-product');

            if (!pricingInner || !pricingList || !productElement) {
                return;
            }

            const productRow = productElement.querySelector('gp-row');
            if (productRow) {
                productRow.style.width = '100%';
            }
            pricingList.insertAdjacentElement('afterend', productElement);

            setTimeout(() => {
                addKeepsakeButtonCopies(productElement);
            }, 0);
        });
    };

    const showPreview = (resizedImageUrl, offerId, originalImageUrl) => {
        if (previewImage) {
            const sourceUrl = resizedImageUrl;
            const shouldWatermark = !originalImageUrl && sourceUrl;
            const previewUrl = shouldWatermark ? buildWatermarkedUrl(sourceUrl) || sourceUrl : sourceUrl;
            const pictureElement = previewImage.closest('picture');
            if (pictureElement) {
                pictureElement.querySelectorAll('source').forEach((source) => source.remove());
            }
            const replacementImage = document.createElement('img');
            const filteredClasses = Array.from(previewImage.classList).filter(
                (className) => !className.toLowerCase().includes('lazy')
            );

            if (filteredClasses.length) {
                replacementImage.className = filteredClasses.join(' ');
            }

            const inlineStyle = previewImage.getAttribute('style');
            if (inlineStyle) {
                replacementImage.setAttribute('style', inlineStyle);
            }

            Array.from(previewImage.attributes).forEach((attr) => {
                if (['class', 'style', 'src', 'srcset'].includes(attr.name)) {
                    return;
                }
                replacementImage.setAttribute(attr.name, attr.value);
            });

            replacementImage.src = previewUrl;
            replacementImage.setAttribute('srcset', previewUrl);
            replacementImage.setAttribute('draggable', 'false');
            replacementImage.addEventListener('contextmenu', (event) => event.preventDefault());
            replacementImage.addEventListener('dragstart', (event) => event.preventDefault());
            previewImage.replaceWith(replacementImage);

            renderPricingCardMockups(previewUrl, sourceUrl);
            enableKeepsakeLightbox();
            revealDownloadRow(originalImageUrl);

            if (offerId) {
                const shareUrl = `https://share.thepawprint.store/o/${offerId}`;
                const shareContainer = replacementImage.parentElement;
                if (shareContainer && !shareContainer.querySelector('.keepsake-share-button')) {
                    shareContainer.style.position = 'relative';

                    const shareButton = document.createElement('button');
                    shareButton.type = 'button';
                    shareButton.className = 'keepsake-share-button';
                    shareButton.setAttribute('aria-label', 'Share your keepsake portrait');
                    shareButton.innerHTML =
                        '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7"/><path d="M12 16V4"/><path d="M7 9l5-5 5 5"/></svg>';
                    shareButton.addEventListener('click', () => {
                        if (navigator.share) {
                            navigator.share({ url: shareUrl }).catch(() => { });
                        }
                    });
                    shareContainer.appendChild(shareButton);
                }
            }
        }

        if (uploadSection) {
            uploadSection.style.display = 'none';
        }
        if (previewSection) {
            previewSection.style.display = 'block';
        }

        updateAttributionWithOfferId(offerId);
        updateUrlWithOfferId(offerId);
        updateMakeAnotherImageUrl();
        setLoadingState(false);
        isProcessing = false;
    };

    const handleOfferData = (offer, fallbackOfferId) => {
        if (!offer) {
            return false;
        }

        const resizedImageUrl = offer.resize_image_urls && offer.resize_image_urls['600'];
        const originalImageUrl = offer.image_url;
        const offerId = offer.offer_id || offer.id || fallbackOfferId;

        if (resizedImageUrl) {
            clearTimers();
            showPreview(resizedImageUrl, offerId, originalImageUrl);
            notifyOfferViewed(offerId);
            return true;
        }

        return false;
    };

    const extractFinalImageUrl = (payload) => {
        if (!payload) return null;
        return (
            payload.image_url ||
            (payload.offer && payload.offer.image_url) ||
            (payload.data && payload.data.image_url)
        );
    };

    const pollForOffer = (offerId) => {
        const fetchUrl = (() => {
            if (!orderId) {
                return `${apiBaseUrl}/${offerId}`;
            }

            const url = new URL(`${apiBaseUrl}/${offerId}`);
            url.searchParams.set('order_id', orderId);
            return url.toString();
        })();

        fetch(fetchUrl, {
            headers: {
                Authorization: `Bearer ${config.fApiToken || ''}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                const resizedImageUrl =
                    (data && data.resize_image_urls && data.resize_image_urls['600']) ||
                    (data && data.offer && data.offer.resize_image_urls && data.offer.resize_image_urls['600']) ||
                    (data && data.data && data.data.resize_image_urls && data.data.resize_image_urls['600']);
                const originalImageUrl = extractFinalImageUrl(data);
                if (resizedImageUrl) {
                    clearTimers();
                    showPreview(resizedImageUrl, offerId, originalImageUrl);
                    notifyOfferViewed(offerId);
                }
            })
            .catch((error) => {
                console.error('Keepsake portrait offer poll failed', error);
            });
    };

    const startPolling = (offerId) => {
        clearPollTimers();
        pollForOffer(offerId);
        pollTimer = setInterval(() => pollForOffer(offerId), 5000);

        pollPaceTimer = setTimeout(() => {
            if (pollTimer) {
                clearInterval(pollTimer);
            }
            pollTimer = setInterval(() => pollForOffer(offerId), 10000);
        }, 25000);

        pollSlowTimer = setTimeout(() => {
            if (pollTimer) {
                clearInterval(pollTimer);
            }
            pollTimer = setInterval(() => pollForOffer(offerId), 20000);
        }, 55000);

        pollStopTimer = setTimeout(() => {
            if (pollTimer) {
                clearInterval(pollTimer);
                pollTimer = null;
            }
            showLoadingError('This is taking longer than expected. Please try again.');
            isProcessing = false;
        }, 95000);
    };

    const handleExistingOfferId = (offerId) => {
        if (!offerId || isProcessing) {
            return;
        }

        isProcessing = true;
        setLoadingState(true);

        if (uploadSection) {
            uploadSection.style.display = 'none';
        }
        if (previewSection) {
            previewSection.style.display = 'block';
        }

        if (handleOfferData(window._offer, offerId)) {
            return;
        }

        const onOfferReady = () => {
            if (handleOfferData(window._offer, offerId)) {
                return;
            }

            startPolling(offerId);
        };

        if (window._offer) {
            onOfferReady();
        } else {
            window.addEventListener('tppData:ready', onOfferReady, { once: true });
        }
    };

    const createOffer = (imageData) => {
        const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
        return fetch(apiBaseUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${config.fApiToken || ''}`,
            },
            body: JSON.stringify({
                image_data: imageData,
                ...(resolvedDogIdParam ? { dog_id: resolvedDogIdParam } : {}),
                ...(utmSource ? { utm_source: utmSource } : {}),
                ...(utmTerm ? { utm_term: utmTerm } : {}),
                ...(fbclid ? { fbclid: fbclid } : {}),
                ...(utmCampaign ? { utm_campaign: utmCampaign } : {}),
                ...(utmContent ? { utm_content: utmContent } : {}),
                ...(expId ? { expid: expId } : {}),
                ...(varId ? { varid: varId } : {}),
                ...(aiPromptTemplateSlug ? { ai_prompt_template_slug: aiPromptTemplateSlug } : {}),
                ...(userAgent ? { user_agent: userAgent } : {}),
            }),
        }).then((response) => response.json());
    };

    const handleFileSelection = (file) => {
        if (!file || isProcessing) {
            return;
        }

        isProcessing = true;
        setLoadingState(true);

        const reader = new FileReader();
        reader.onload = () => {
            const imageData = reader.result;
            if (!imageData || typeof imageData !== 'string') {
                setLoadingState(false);
                isProcessing = false;
                return;
            }

            createOffer(imageData)
                .then((data) => {
                    const offerId = data && (data.offer_id || data.offerId || data.id);
                    if (!offerId) {
                        throw new Error('Missing offer id from keepsake portrait response');
                    }

                    pollDelayTimer = setTimeout(() => {
                        startPolling(offerId);
                    }, 40000);
                })
                .catch((error) => {
                    console.error('Failed to create keepsake portrait offer', error);
                    setLoadingState(false);
                    isProcessing = false;
                });
        };
        reader.onerror = () => {
            setLoadingState(false);
            isProcessing = false;
        };
        reader.readAsDataURL(file);
    };

    input.addEventListener('change', (event) => {
        const target = event.target;
        const file = target && target.files && target.files[0];
        handleFileSelection(file);
    });

    rearrangePricingCards();
    startPricingTimers();
    bindPricingLinkModal();

    const applyReminderOfferId = (offer) => {
        const offerId = offer && (offer.offer_id || offer.id);
        if (!offerId) {
            return null;
        }

        updateAttributionWithOfferId(offerId);
        updateUrlWithOfferId(offerId);
        return offerId;
    };

    const handleReminderOffer = () => {
        if (!keepsakeReminder || existingOfferId || isProcessing) {
            return;
        }

        const reminderOfferId = applyReminderOfferId(window._offer);
        handleOfferData(window._offer, reminderOfferId);
    };

    if (existingOfferId) {
        handleExistingOfferId(existingOfferId);
    } else if (keepsakeReminder) {
        if (window._offer) {
            handleReminderOffer();
        } else {
            window.addEventListener('tppData:ready', handleReminderOffer, { once: true });
        }
    }
}

window.setupKeepsakePortrait = setupKeepsakePortrait;
